// Generated by 'yarn run build:variables'. Do not edit.
const globals = {
  '$facebook-color': '#3b5998',
  '$linkedin-color': '#007bb6',
  '$twitter-color': '#4099ff',
  '$white': '#fff',
  '$gray-darker': '#222',
  '$gray-dark': '#333',
  '$gray': '#555',
  '$gray-light': '#999',
  '$gray-lighter': '#ccc',
  '$gray-lightest': '#eee',
  '$brand-primary': '#00638f',
  '$brand-success': '#8dba15',
  '$brand-warning': '#f9d549',
  '$brand-danger': '#d9534f',
  '$body-bg': '#eee',
  '$text-color': '#333',
  '$link-color': '#09c',
  '$link-hover-color': '#006080',
  '$link-hover-decoration': 'underline',
  '$bold': '600',
  '$font-family-sans-serif': '"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif',
  '$font-family-mailers': 'Verdana,Arial,sans-serif',
  '$font-family-mailers-base': '12px',
  '$font-size-base': '14px',
  '$font-size-large': '18px',
  '$font-size-small': '12px',
  '$font-size-xs': '11px',
  '$font-size-h1': '36px',
  '$font-size-h2': '30px',
  '$font-size-h3': '24px',
  '$font-size-h4': '18px',
  '$font-size-h5': '14px',
  '$font-size-h6': '12px',
  '$headings-font-weight': '600',
  '$headings-color': '#005176',
  '$heading-letter-spacing': '-0.025em',
  '$padding-base-vertical': '6px',
  '$padding-base-horizontal': '12px',
  '$border-radius-base': '3px',
  '$border-radius-large': '4px',
  '$border-radius-small': '2px',
  '$btn-font-weight': 'normal',
  '$btn-default-color': '#333',
  '$btn-default-bg': '#eee',
  '$btn-default-border': '#ccc',
  '$btn-primary-color': '#fff',
  '$btn-primary-bg': '#3f98bd',
  '$btn-primary-border': '#3989aa',
  '$btn-success-color': '#fff',
  '$btn-success-bg': '#8dba15',
  '$btn-success-border': '#7ca312',
  '$btn-warning-color': '#fff',
  '$btn-warning-bg': '#f7880d',
  '$btn-warning-border': '#e37b08',
  '$input-bg-disabled': '#e6e6e6',
  '$input-group-addon-bg': '#f3f3f3',
  '$mobile-screen-sm-max': '320px',
  '$mobile-screen-md-min': '321px',
  '$mobile-screen-md-max': '375px',
  '$mobile-screen-lg-min': '376px',
  '$mobile-screen-lg-max': '425px',
  '$screen-xs': '480px',
  '$screen-xs-min': '480px',
  '$screen-sm-min-int': '768',
  '$screen-sm': '768px',
  '$screen-sm-min': '768px',
  '$screen-md': '992px',
  '$screen-md-min': '992px',
  '$screen-lg': '1200px',
  '$screen-lg-min': '1200px',
  '$screen-xs-max': '767px',
  '$screen-sm-max': '991px',
  '$screen-md-max': '1199px',
  '$grid-columns': '12',
  '$grid-gutter-width': '30px',
  '$grid-float-breakpoint': '1px',
  '$navbar-animation-time': '.3s',
  '$navbar-height': '50px',
  '$navbar-border-radius': '0',
  '$navbar-padding-horizontal': '15px',
  '$navbar-inverse-color': '#eee',
  '$navbar-inverse-bg': '#00638f',
  '$navbar-inverse-border': '0 none',
  '$state-warning-bg': '#fefbec',
  '$state-warning-border': '#fbe6bc',
  '$state-danger-text': '#a94442',
  '$alert-link-font-weight': '600',
  '$list-group-hover-bg': '#f5fcff',
  '$list-group-disabled-bg': '#eee',
  '$panel-body-padding': '10px',
  '$panel-heading-padding': '10px',
  '$badge-font-weight': '600',
  '$close-font-weight': '600',
  '$text-muted': '#999',
  '$navbar-inverse-link-color': '#eee',
  '$navbar-inverse-toggle-border-color': 'transparent',
  '$navbar-inverse-toggle-hover-bg': 'transparent',
  '$panel-inverse-border': '#a2a2a2',
  '$panel-inverse-heading-bg': '#6f6f6f',
  '$panel-inverse-body-bg': '#eee',
  '$panel-inverse-text': '#eee',
  '$offcanvas-default-bg': '#f3f3f3',
  '$offcanvas-inverse-bg': '#555',
  '$offcanvas-width': '300px',
  '$offcanvas-animation-time': '.15s',
  '$offcanvas-toggle-bars-color': '#000',
  '$mobile_query': '"(max-width: 767px)"',
  '$tablet_query': '"(min-width: 768px) and (max-width: 991px)"',
  '$desktop_query': '"(min-width: 992px)"',
  '$tablet_and_desktop_query': '"(min-width: 768px)"',
  '$ie10_and_ie11_query': '"screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"',
  '$ie9_and_ie10_query': '"screen and (min-width:0\\0)"'
}
export default globals



// WEBPACK FOOTER //
// ./frontend/src/ui_globals.js